import zhCN from "./zh-CN";
import zhTW from "./zh-TW";
import zhHK from "./zh-HK";
import en from "./en";

const resources = {
  "zh-CN": {
    translation: zhCN,
  },
  "zh-TW": {
    translation: zhTW,
  },
  "zh-HK": {
    translation: zhHK, // 目前 zh-HK.js 内部是复用 zh-TW
  },
  en: {
    translation: en,
  },
};

export { resources };
